import API from '../config/api';
import React, { useState, useEffect } from 'react';

import axios from 'axios';

import { Container, Card, Form, Button } from 'react-bootstrap';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

import CustomNavbar from '../components/CustomNavbar';
import ImageReorderGrid from '../components/ImageReorderGrid';
import ImageCropperModal from '../components/ImageCropperModal';

function AddProductPage() {
  const navigate = useNavigate();

  const [product, setProduct] = useState({
    name: '',

    category: '',

    image: '',

    price: '',

    stock: '',

    topSale: false,

    shortDescription: '',

    description: '',

    highlights: ''
  });

  const [imageFiles, setImageFiles] = useState([]);

  const [loading, setLoading] = useState(false);

  const MIN_IMAGES = 5;

  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.get(
          `${API}/categories`
        );

        setCategories(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCategories();
  }, []);
  const handleChange = (e) => {
    setProduct({
      ...product,

      [e.target.name]: e.target.value
    });
  };

  /* Reorder previews — position 0 becomes the main thumbnail */
  const moveImage = (from, to) => {
    if (to < 0 || to >= imageFiles.length) return;
    const next = [...imageFiles];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    setImageFiles(next);
  };

  const removeImage = (index) => {
    setImageFiles(imageFiles.filter((_, i) => i !== index));
  };

  /* Crop / adjust a selected image before upload */
  const [cropIndex, setCropIndex] = useState(null);
  const [cropSrc, setCropSrc] = useState(null);

  const openCropper = (index) => {
    setCropIndex(index);
    setCropSrc(URL.createObjectURL(imageFiles[index]));
  };

  const applyCrop = (file) => {
    setImageFiles(imageFiles.map((f, i) => (i === cropIndex ? file : f)));
    setCropIndex(null);
    setCropSrc(null);
  };

  const uploadImages = async () => {
    if (!imageFiles.length) return [];

    const formData = new FormData();

    imageFiles.forEach((file) => formData.append('images', file));

    try {
      const { data } = await axios.post(
        `${API}/upload/multiple`,

        formData,

        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      return data.images || [];
    } catch (error) {
      console.log(error);

      toast.error('Image Upload Failed');

      return [];
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (imageFiles.length < MIN_IMAGES) {
      toast.warning(`Please add at least ${MIN_IMAGES} images`);
      return;
    }

    try {
      setLoading(true);

      const uploaded = await uploadImages();

      if (uploaded.length < MIN_IMAGES) {
        toast.error(`Image upload failed — need at least ${MIN_IMAGES} images`);
        setLoading(false);
        return;
      }

      await axios.post(
        `${API}/products`,

        {
          name: product.name,

          category: product.category,

          image: uploaded[0],

          images: uploaded,

          price: Number(product.price),

          stock: Number(product.stock),

          topSale: product.topSale,

          shortDescription: product.shortDescription,

          description: product.description,

          highlights: product.highlights
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '')
        }
      );

      toast.success('Product Added Successfully');

      navigate('/admin/products');
    } catch (error) {
      console.log(error);

      toast.error(error.response?.data?.message || 'Failed To Add Product');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.get(
          `${API}/categories`
        );

        setCategories(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <CustomNavbar />

      <Container className="mt-5">
        <Card
          className="p-4 shadow border-0"
          style={{
            borderRadius: '20px'
          }}
        >
          <h2 className="mb-4">📦 Add Product</h2>

          <Form onSubmit={submitHandler}>
            <Form.Group className="mb-3">
              <Form.Label>Product Name</Form.Label>

              <Form.Control
                type="text"
                name="name"
                value={product.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>

              <Form.Select
                name="category"
                value={product.category}
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>

                {categories.map((category) => (
                  <option key={category._id} value={category.name}>
                    {category.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                Product Images (minimum {MIN_IMAGES})
              </Form.Label>

              <Form.Control
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => setImageFiles(Array.from(e.target.files))}
              />

              <Form.Text
                className={
                  imageFiles.length >= MIN_IMAGES
                    ? 'text-success'
                    : 'text-muted'
                }
              >
                {imageFiles.length} selected
                {imageFiles.length < MIN_IMAGES
                  ? ` — add ${MIN_IMAGES - imageFiles.length} more`
                  : ' ✓'}
                . The first image is used as the main thumbnail.
              </Form.Text>
            </Form.Group>

            <ImageReorderGrid
              images={imageFiles.map((f) => URL.createObjectURL(f))}
              onMove={moveImage}
              onRemove={removeImage}
              onEdit={openCropper}
            />

            <ImageCropperModal
              show={cropIndex !== null}
              src={cropSrc}
              onApply={applyCrop}
              onHide={() => {
                setCropIndex(null);
                setCropSrc(null);
              }}
            />

            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>

              <Form.Control
                type="number"
                name="price"
                value={product.price}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Stock Quantity</Form.Label>

              <Form.Control
                type="number"
                min="0"
                name="stock"
                value={product.stock}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"

                label="Add To Top Sale Products"

                checked={product.topSale}

                onChange={(e) =>
                  setProduct({
                    ...product,

                    topSale: e.target.checked
                  })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Short Description</Form.Label>

              <Form.Control
                type="text"
                name="shortDescription"
                value={product.shortDescription}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Description</Form.Label>

              <Form.Control
                as="textarea"
                rows={4}
                name="description"
                value={product.description}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Product Highlights</Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                name="highlights"
                value={product.highlights}
                onChange={handleChange}
                placeholder="Example:
12GB RAM, 256GB Storage, 6000mAh Battery, 120Hz AMOLED Display"
              />

              <Form.Text className="text-muted">
                Separate each highlight using commas (,)
              </Form.Text>
            </Form.Group>

            <Button type="submit" variant="success" disabled={loading}>
              {loading ? 'Uploading...' : 'Add Product'}
            </Button>
          </Form>
        </Card>
      </Container>
    </>
  );
}

export default AddProductPage;
